import styled from "styled-components";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: 1400px; /* Increased from 1200px */
  margin-right: auto;
  margin-left: auto;
  padding: 0 60px;
  overflow: hidden;
  border-top: ${(p) => (p.border ? "1px solid #CDD1D4" : "")};
  box-sizing: border-box;

  @media only screen and (max-width: 1400px) {
    max-width: 95%; /* Use percentage instead of fixed width */
  }

  @media only screen and (max-width: 1024px) {
    padding: 0 40px;
  }

  @media only screen and (max-width: 768px) {
    padding: 0 30px;
    max-width: 100%;
  }

  @media only screen and (max-width: 480px) {
    padding: 0 20px;
  }
`;